const name = "UI";

export const SHOW_LOADER = `${name}/SHOW_LOADER`;
export const HIDE_LOADER = `${name}/HIDE_LOADER`;

export const SHOW_MODAL = `${name}/SHOW_MODAL`;
export const HIDE_MODAL = `${name}/HIDE_MODAL`;
export const HIDE_MODALS = `${name}/HIDE_MODALS`;
export const HIDE_MODALS_EXCEPT_DAPP = `${name}/HIDE_MODALS_EXCEPT_DAPP`;

export const SET_EMBED_MODE = `${name}/SET_EMBED_MODE`;
